/* -------------------------------------------------------------------------- */
/*                       Reset Validation                                  */
/* -------------------------------------------------------------------------- */
import vv_utils from './vv_utils';
import { fullInvokeMachine } from "./vv_api";
import {redirectRequest} from "./vv_c";

const resetValidationInit = () => {
  const fieldFormMap = {
    "password": "#split-password",
  }

  const alertbox = document.getElementById("split-alert");

  const urlparams = new URLSearchParams(window.location.search);
  const token = urlparams.get('token');

  /* eslint-disable */
  /*
  This is a bit unique because it does a redirect on the normal happy path
  Example input
  let userstate = { 'username': email, 'password': password, 'provider': submitter.value, 'profile': {'email': email, 'name': name} };
  */
  /* eslint-enable */
  const resetUser = (userstate) => {
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/password/reset`, userstate, 'POST', vv_utils.defaultTimeout);
  }
  
  //This had to be done manually instead of using bootstrap because we
  //added a custom 'eye' icon through a container div that did not allow for a 
  //feedback div directly under the input tag like normal
  function clearPasswordFeedback() {
    let passwordfeedback = document.getElementById('split-password-feedback');

    passwordfeedback.style.display = 'none';

    let confirmpasswordfeedback = document.getElementById('split-confirm-password-feedback');

    confirmpasswordfeedback.style.display = 'none';
    

    let confirmPassword = document.getElementById('split-confirm-password');
    //confirmPassword.classList.remove(':valid');
    //confirmPassword.classList.remove(':invalid');
    //confirmPassword.classList.remove('is-invalid');
    confirmPassword.setCustomValidity('');


    let password = document.getElementById('split-password');
    password.classList.remove(':valid');
    password.classList.remove(':invalid');

  }

  function checkValidity(errorCB){
    return new Promise((resolve, reject)=>{
      let valid = true;
      let password = document.getElementById('split-password');
      let passwordfeedback = document.getElementById('split-password-feedback');
      let confirmPassword = document.getElementById('split-confirm-password');
      let confirmPasswordFeedback = document.getElementById('split-confirm-password-feedback');

      // eslint-disable-next-line
      if (password.value && confirmPassword.value && ( password.value === confirmPassword.value)  && (password.value.length >= 10) && (password.value.length <= 255)) {
        clearPasswordFeedback();
      } else {
          vv_utils.makeInvalid(password);
          vv_utils.makeInvalid(confirmPassword);
          if (!(password.value === confirmPassword.value)) {
            //custome rules for confirm means we need to also set :invalid on the field 
            //and not just the feedback
            //confirmPassword.classList.remove(':valid');
            //confirmPassword.classList.remove('is-valid');

            confirmPassword.setCustomValidity('invalid');

            confirmPasswordFeedback.style.display = 'block';
            confirmPasswordFeedback.innerText = "Password and confirm password do not match";
            
          }
          else {
            // see the comments above clearPasswordFeedback

            passwordfeedback.style.display = 'block';
            //passwordfeedback.innerText = "Please enter a valid password";
            
          }
          
          valid = false;
      }
          
      if (token === '' || !token){
        valid = false;
      }

      if(valid){
        return resolve("valid");
      } else {
        if(token === '' || !token){
          throw new vv_utils.ShowableException("Invaild token, try to copy and paste the link again.");
        } else {
          return reject(new Error('not valid'));
        }
      }
    })
  }

  function resetFormSubmit(e){
    if (e.preventDefault) e.preventDefault();
  }

  function doReset(context, event) {
    let password = document.getElementById('split-password').value;
    
    // eslint-disable-next-line
    let userstate = { 'password': password, 'token': token };
    return resetUser(userstate);
  }

  const { interpret } = window.XState;

  const form = document.getElementById("reset-form");
  if (form && form !== null) {
    const validationService = interpret(
      fullInvokeMachine.withConfig({
        actions: {
          loaded: () => {
          },
          message: (context, event) => {
            vv_utils.clearInputValidation(form);
            vv_utils.clearalert(alertbox);
            clearPasswordFeedback();
          },
          validationFailed: (context, event) => {
            
            vv_utils.showStateErrors("There are validation errors, fix fields highlighted in red and submit again.", context.error , alertbox);
          },
          validationSucceeded: () => {
            validationService.send("PERFORM_ACTION");
          },
          actionFailed: (context, event) => {
            
            if(context.error.fields){
              const invalidIds = context.error.fields.map((field) => fieldFormMap[field]);
              invalidIds.forEach((id)=>{
                vv_utils.makeInvalid(id);
              })
            }
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error , alertbox);
          },
          //eslint-disable-next-line
          actionSucceeded: (context, event) => {
            const jsonResponse = window._.pick(context.data , Object.keys(redirectRequest));
            window.location.assign(jsonResponse.redirect);
            validationService.send("LOAD_COMPLETE");
          }
        },
        services: {
          validate_service: (context, event) => checkValidity(context, event),
          action_service: (context, event) => {return doReset(context, event)}
        }
      })
    )
    .onTransition((state) => {})
    .start();
    
    //eslint-disable-next-line
    vv_utils.addFormAndMachineServiceChangeAndInputHandlers(form, validationService, resetFormSubmit);

    vv_utils.AttachAndSendFormEventsToMachineService(form, validationService, 'input', 'input');
  
    //After the state machince is fully configured, move out of loading
    validationService.send("LOAD_COMPLETE");
  }

}

export default resetValidationInit;
